import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

import { urlPath } from '@/utils/lpPath'

import { ContactParams } from './ContactContainer'

type Props = {
  values: ContactParams
  back: () => void
  targetValue: string
  submit: () => void
}
const ContactConfirm: React.FC<Props> = ({ values, back, targetValue, submit }) => {
  return (
    <>
      <main>
        <div className="contact">
          <div id="contactNavbarPC" className="flex justify-between sp:hidden">
            <Link href={urlPath.top}>
              <a>
                <Image
                  className=""
                  src="/images/logo/atsougi_logo.png"
                  alt="logo"
                  width="120"
                  height="55"
                  layout="raw"
                />
              </a>
            </Link>
          </div>
          <div id="contactNavbarSP" className="flex justify-between pc:hidden">
            <Link href={urlPath.top}>
              <a>
                <Image
                  className=""
                  src="/images/logo/atsougi_logo.png"
                  alt="logo"
                  width="105"
                  height="48"
                  layout="raw"
                />
              </a>
            </Link>
          </div>
          <div className="body">
            <div className="section">
              <div className="faqCaption mb-16">
                <p className="caption">お問い合わせ</p>
              </div>
              <p className="mb-16">※以下の内容で送信します。</p>
              <ul className="contactForm">
                <li>
                  <p>お問い合わせ種別</p>
                  <p>{values.otoiawasesyubetsu_atsougi}</p>
                </li>
                {targetValue === '法人のお客様' && (
                  <>
                    <li>
                      <p>店名・企業名</p>
                      <p>{values.company}</p>
                    </li>
                    <li>
                      <p>ご担当者様名</p>
                      <p>{values.firstname + ' ' + values.lastname}</p>
                    </li>
                  </>
                )}
                {targetValue === '個人のお客様' && (
                  <>
                    <li>
                      <p>お名前</p>
                      <p>{values.firstname + ' ' + values.lastname}</p>
                    </li>
                  </>
                )}
                <li>
                  <p>メールアドレス</p>
                  {values.email}
                </li>
                <li>
                  <p>お電話番号</p>
                  {values.phone}
                </li>
                <li>
                  <p>エリア</p>
                  {values.syozaichi}
                </li>
                <li className="contentsConfirm">
                  <p>お問い合わせ内容</p>
                  <p className="whitespace-pre-wrap break-all">{values.toiawasenaiyou}</p>
                </li>
              </ul>
              <div className="text-center mt-12">
                <button onClick={back} className="sp:hidden contactBackButton mr-4">
                  戻る
                </button>
                <button onClick={submit} className="contactSubmit">
                  送信
                </button>
                <button onClick={back} className="pc:hidden contactBackButton mr-4">
                  戻る
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}
export default ContactConfirm
